<template>
  <v-card outlined max-width="600" class="mx-auto my-10">
    <v-layout>
      <v-flex>
        <div v-if="this.data.image" class="mb-5">
          <v-card tile elevation="0" width="100%">
            <v-img
              aspect-ratio="1"
              :src="this.data.image.url"
              :lazy-src="this.data.image.url"
            />
          </v-card>
        </div>
        <div class="ma-5">
          {{ this.data.content }}
          <div class="caption mt-2">
            {{ iMoment(this.data.createdAt) }}
          </div>
          <div class="mb-2 caption grey--text">
            {{ this.data.id }}
          </div>
          <v-layout class="mt-4 subtitle-1 font-weight-bold">
            <v-chip color="yellow" light class="mr-3">
              <v-icon small class="mr-2">
                mdi-eye
              </v-icon>

              {{ this.data.views }}
            </v-chip>
            <v-chip dark :color="this.data.score >= 0 ? 'green' : 'red'">
              <v-icon class="mr-1">
                {{ this.data.score >= 0 ? 'mdi-arrow-up' : 'mdi-arrow-down' }}
              </v-icon>
              {{ this.data.score }}
            </v-chip>
            <v-chip @click="commentItem" dark color="grey" class="ml-3">
              <v-icon small class="mr-2">
                mdi-forum
              </v-icon>

              {{ this.data.totalComments }}
            </v-chip>
            <v-spacer />
            <v-btn @click="deleteItem" dark fab x-small color="red">
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </v-layout>
        </div>

        <div>
          <v-divider />
        </div>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import moment from 'moment';
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp._seconds * 1000;
        return moment(temp).format('lll');
      } else {
        return 0;
      }
    },
    deleteItem() {
      console.log('Delete');
      this.$emit('delete-item', this.data);
    },
    commentItem() {
      this.$emit('comment-item', this.data);
    },
  },
};
</script>

<style></style>
